<ul>
  @for (cf of history(); track cf.gameid;) {
  <li>
    <button (click)="viewGame(cf)">
      @if (cf.winner) {
      <app-coinflip-coin [side]="cf.winner.side"></app-coinflip-coin>
      } @else {
      <span>winner is empty</span>
      }
    </button>
  </li>
  }
</ul>
